import { TableMenuActionColorEnums } from '@/enums/TableMenuActionEnums';

export interface ITableItemColor {
    sectionIdentifier: string;
    subSectionIdentifier?: string;
    sampleSubSectionId?: string;
    fieldIdentifier: string;
    color: TableMenuActionColorEnums;
}

export class TableItemColor implements ITableItemColor {
    public sectionIdentifier: string;
    public subSectionIdentifier?: string;
    public sampleSubSectionId?: string;
    public fieldIdentifier: string;
    public color: TableMenuActionColorEnums;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableItemColor);
    constructor(obj?: any) {
        this.sectionIdentifier = obj && obj.sectionIdentifier || '';
        this.fieldIdentifier = obj && obj.fieldIdentifier || '';
        this.color = obj && obj.color || TableMenuActionColorEnums.UNMARK;
        if (obj && obj.subSectionIdentifier != null) {
            this.subSectionIdentifier = obj.subSectionIdentifier;
        }
        if (obj && obj.sampleSubSectionId != null) {
            this.sampleSubSectionId = obj.sampleSubSectionId;
        }
    }
}
